"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrapperStanding = exports.WrapperIntended = exports.ListItem = exports.Divider = exports.Bullet = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var ListItem = _styledComponents.default.li(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: #fff;\n  font-size: 16px;\n"])));
exports.ListItem = ListItem;
var Divider = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: 32px;\n\n  // Content comes from the backed that's why a class name can't be used\n  a {\n    color: #febf32;\n    font-weight: bold;\n  }\n\n  @media screen and (max-width: 420px) {\n    margin-bottom: 32px;\n  }\n  ", ";\n"])), function (_ref) {
  var $bsStyle = _ref.$bsStyle;
  return $bsStyle || '';
});
exports.Divider = Divider;
var Bullet = _styledComponents.default.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 22px;\n  margin-right: 4px;\n"])));
exports.Bullet = Bullet;
var WrapperStanding = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: block;\n  margin-bottom: 8px;\n"])));
exports.WrapperStanding = WrapperStanding;
var WrapperIntended = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: ", ";\n"])), function (_ref2) {
  var justifyContent = _ref2.justifyContent;
  return justifyContent;
});
exports.WrapperIntended = WrapperIntended;